import '../css/mainCss.css'
import axios from 'axios';
import ChatContainer from '../components/chatContainer.js'


axios.defaults.withCredentials = true;

function ChatPage() {
   return(
    <div className=' homeview center'>  
        <div className='mainArea'>
            <div className='title'> Chat with assistant </div>
            <div className="chatArea justify-content-center flex-grow-1">
                <ChatContainer></ChatContainer>
            </div>
        </div>
    </div>
   );

}

export default ChatPage;
